import RewardLoyaltyPointsTab from '../components/RewardLoyaltyPointsTab';
import RewardCenterHistory from '../components/RewardCenterHistory';
import RewardProfileTab from '../components/RewardProfileTab';
import RewardCenterHistoryDetail from '../components/RewardCenterHistoryDetail';
import { REWARD_CENTER_TABS } from 'shared/screens/RewardCenter/constants';

export const RewardTabContent = {
  [REWARD_CENTER_TABS.HOME]: RewardProfileTab,
  [REWARD_CENTER_TABS.HISTORY]: RewardCenterHistory,
  [REWARD_CENTER_TABS.HISTORY_DETAIL]: RewardCenterHistoryDetail,
  [REWARD_CENTER_TABS.PROFILE]: RewardProfileTab,
  [REWARD_CENTER_TABS.LOYALTY_POINTS]: RewardLoyaltyPointsTab,
};

